<template>
  <div class="py-1">
    <MenuOption
      v-if="canSchedule"
      id="schedule-send"
      :title="$t('W: Planlæg afsendelse')"
      @select="onScheduleClick">
      <template #icon>
        <IconLucideCalendarClock class="h-4 w-4" />
      </template>
    </MenuOption>
    <MenuOption
      id="mark-sent-manually"
      :title="$t('W: Generer og marker som manuelt sendt')"
      @select="onMarkSentManuallyClick">
      <template #icon>
        <IconLucideCheckCheck class="h-4 w-4" />
      </template>
    </MenuOption>
  </div>
</template>

<script lang="ts">
import type { PropType } from 'vue'

/**
 * The alternatives to "Send" on a delivery parked in "Godkendt – ikke sendt", behind the split
 * button's chevron: schedule it for its delivery day, or generate the report and mark it as handled outside the system.
 */
export default {
  name: 'OrderApprovedDeliveryMenu',

  emits: ['close'],

  props: {
    onMarkSentManually: {
      type: Function as PropType<() => void>,
      required: true,
    },
    onSchedule: { type: Function as PropType<() => void>, required: true },
    /**
     * False for a walk-in TAT, and once the send moment has passed — same rule as the approve
     * menu's "Godkend og planlæg".
     */
    canSchedule: { type: Boolean, default: false },
  },

  methods: {
    onScheduleClick(): void {
      this.onSchedule()
      this.$emit('close')
    },

    onMarkSentManuallyClick(): void {
      this.onMarkSentManually()
      this.$emit('close')
    },
  },
}
</script>
